<template>
    <div>
        <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#005f32"
            spinner="bar-fade-scale" />
        <v-snackbar v-model="showsnackbar" color="black" right>
            <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
                <v-flex text-right>
                    <v-btn small :ripple="false" text @click="showsnackbar = false">
                        <v-icon style="color: white">mdi-close</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-snackbar>
        <v-layout wrap>
            <v-flex xs12>
                <v-card-title class="elevation-0">
                    <span class="itemHeading">Important Dates</span>
                    <v-spacer></v-spacer>
                    <v-flex xs6 sm6 md3 pt-5 align-self-center text-right>
                        <v-btn color="#005f32" rounded outlined class="mb-4" @click="addImportantDate = true">
                            <span style="font-family: kumbhRegular;">Add</span>
                        </v-btn>
                    </v-flex>
                </v-card-title>
                <v-layout wrap justify-start pa-4 v-if="importantDates.length > 0">
                    <v-flex xs12>
                        <v-simple-table class="align-center">
                            <template v-slot:default>
                                <thead style="background-color: #005f32">
                                    <tr>
                                        <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                                            Title
                                        </th>
                                        <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                                            Date
                                        </th>
                                        <th style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " class="text-left">
                                            Description
                                        </th>
                                        <th style="
                                        font-size: 15px;
                                        color: #ffffff;
                                        font-family: kumbhRegular;
                                      " class="text-left">
                                            Edit
                                        </th>
                                        <th style="
                                        font-size: 15px;
                                        color: #ffffff;
                                        font-family: kumbhRegular;
                                      " class="text-left">
                                            Delete
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="align-center">
                                    <tr class="text-left align-center" v-for="(item, i) in importantDates" :key="i">
                                        <td>
                                            <span v-if="item.title" style="font-family: kumbhMedium">{{
                                                item.title
                                                }}</span>
                                        </td>
                                        <td>
                                            <span v-if="item.date" style="font-family: kumbhMedium">{{
                                                formatDate(item.date) }}</span>
                                        </td>
                                        <td>
                                            <span v-if="item.description" style="font-family: kumbhMedium">{{
                                                item.description }}</span>
                                            <span v-else style="font-family: kumbhMedium">No description</span>
                                        </td>
                                        <td>
                                            <v-layout wrap>
                                                <v-flex xs12 align-self-center text-left>
                                                    <v-icon small color="#005f32" @click="editItem(item)">
                                                        mdi-pencil</v-icon></v-flex>
                                            </v-layout>
                                        </td>
                                        <td>
                                            <v-layout wrap>
                                                <v-flex xs12 align-self-center text-left>
                                                    <v-icon small color="error" @click="openDeleteDialog(item)">
                                                        mdi-delete</v-icon></v-flex>
                                            </v-layout>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-flex>
                </v-layout>
                <v-layout wrap v-else>
                    <v-flex xs12 align-self-center pa-16>
                        <span class="kumbhRegular">No Data found!</span>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout wrap justify-center v-if="pages > 0">
            <v-flex align-self-center>
                <div class="pt-2">
                    <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages"
                        :total-visible="7" v-model="currentPage" color="#005f32"></v-pagination>
                </div>
            </v-flex>
        </v-layout>
        <!-- add Important Date  -->
        <v-dialog persistent v-model="addImportantDate" max-width="600px">
            <v-card>
                <v-layout wrap>
                    <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
                        <v-layout wrap>
                            <v-flex xs6 align-self-center text-left>
                                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                                    Add Important Date</span>
                            </v-flex>
                            <v-flex xs6 align-self-center text-right>
                                <v-btn icon color="white" text @click="addImportantDate = false">
                                    <v-icon color="#ffffff">mdi-close</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-4></v-flex>
                    <v-flex xs12>
                        <v-layout wrap px-5 pb-8>
                            <!-- Title Field -->
                            <v-flex xs12 sm12 align-self-center text-left pa-2>
                                <v-text-field v-model="title" label="Title" required outlined dense
                                    hide-details></v-text-field>
                            </v-flex>

                            <!-- Date Field (YYYY-MM-DD format) -->
                            <v-flex xs12 sm12 align-self-center text-left pa-2>
                                <v-menu v-model="menuAdd" :close-on-content-click="false" transition="scale-transition"
                                    offset-y min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="date" label="Date" readonly outlined
                                            hide-details dense v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker color="#005f32" v-model="date"
                                        :picker-date.sync="pickerDateAdd" scrollable
                                        @input="menuAdd = false"></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <!-- Description Field -->
                            <v-flex xs12 sm12 align-self-center text-left pa-2>
                                <v-textarea v-model="description" label="Description" outlined dense
                                    hide-details rows="3"></v-textarea>
                            </v-flex>

                            <!-- Add Button -->
                            <v-flex xs12 text-end pt-3 pa-2>
                                <v-btn @click="addImportantDateItem()" color="#005f32">
                                    <span class="kumbhBold" style="color: white">Add</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!-- Edit Important Date  -->
        <v-dialog persistent v-model="editdialog" max-width="600px">
            <v-card>
                <v-layout wrap>
                    <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
                        <v-layout wrap>
                            <v-flex xs6 align-self-center text-left>
                                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">Edit Important Date</span>
                            </v-flex>
                            <v-flex xs6 align-self-center text-right>
                                <v-btn icon color="white" text @click="editdialog = false">
                                    <v-icon color="#ffffff">mdi-close</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs12 pa-4></v-flex>

                    <v-flex xs12>
                        <v-layout wrap px-5 pb-8>
                            <!-- Title Field -->
                            <v-flex xs12 sm12 align-self-center text-left pa-2>
                                <v-text-field v-model="editingitem.title" label="Title" required outlined
                                    dense hide-details></v-text-field>
                            </v-flex>

                            <!-- Date Field (YYYY-MM-DD format) -->
                            <v-flex xs12 sm12 align-self-center text-left pa-2>
                                <v-menu v-model="menuEdit" :close-on-content-click="false" transition="scale-transition"
                                    offset-y min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="editingitem.date" label="Date" readonly
                                            outlined hide-details dense v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker color="#005f32" v-model="editingitem.date"
                                        :picker-date.sync="pickerDateEdit" scrollable
                                        @input="menuEdit = false"></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <!-- Description Field -->
                            <v-flex xs12 sm12 align-self-center text-left pa-2>
                                <v-textarea v-model="editingitem.description" label="Description" outlined dense
                                    hide-details rows="3"></v-textarea>
                            </v-flex>

                            <!-- Edit Button -->
                            <v-flex xs12 text-end pt-3 pa-2>
                                <v-btn @click="updateImportantDate()" color="#005f32">
                                    <span class="kumbhBold" style="color: white">Edit</span>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
        <!-- delete  Important Date -->
        <v-dialog persistent v-model="deletedialog" max-width="600px">
            <v-card>
                <v-layout wrap>
                    <v-flex xs12 pa-4 text-left align-self-center style="background: #005f32 !important">
                        <v-layout wrap>
                            <v-flex xs6 align-self-center text-left>
                                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                                    Delete Important Date
                                </span>
                            </v-flex>
                            <v-flex xs6 align-self-center text-right>
                                <v-btn icon color="white" text @click="deletedialog = false">
                                    <v-icon color="#ffffff">mdi-close</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 pa-4></v-flex>
                    <v-flex xs12>
                        <v-layout wrap px-5 pb-8>
                            <v-flex xs12 align-self-center text-left>
                                <span class="kumbhBold" style="color: #000; font-size: 20px">Are you sure you want to
                                    delete
                                    this
                                    important date?</span>
                            </v-flex>

                            <v-flex xs12 align-self-center text-right pt-3>
                                <v-btn @click="confirmDelete" color="#005f32">
                                    <span class="kumbhBold" style="color: white"> Delete</span>
                                </v-btn></v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        showsnackbar: false,
        ServerError: false,
        msg: null,
        pages: 0,
        dialog: false,
        itemToDelete: null,
        deletedialog: false,
        pageCount: 1,
        appLoading: false,
        currentPage: 1,
        importantDates: [],
        addImportantDate: false,
        title: '',
        date: '',
        description: '',
        menuAdd: false,
        pickerDateAdd: '',
        menuEdit: false,
        pickerDateEdit: '',
        editdialog: false,
        editingitem: {},
    }),
    computed: {
    },
    mounted() {
        if (this.$store && this.$store.state && this.$store.state.currentPage) {
            this.currentPage = this.$store.state.currentPage;
            this.getData();
        }
        else this.getData();
    },
    methods: {
        editItem(item) {
            // Create a copy of the item to avoid direct mutation
            this.editingitem = { ...item };

            // Ensure date is in 'YYYY-MM-DD' format
            if (this.editingitem.date) {
                const date = new Date(this.editingitem.date);
                const year = date.getFullYear();
                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                const day = ("0" + date.getDate()).slice(-2);
                this.editingitem.date = `${year}-${month}-${day}`;
            }

            // Open the edit dialog
            this.editdialog = true;
        },
        updateImportantDate() {
            var data = {
                title: this.editingitem.title,
                date: this.editingitem.date,
                description: this.editingitem.description
            };

            this.appLoading = true;
            axios({
                url: `/important-dates/edit/${this.editingitem._id}`,
                method: "POST",
                data: data,
                headers: {
                    'x-auth-token': localStorage.getItem("token"),
                },
            })
                .then((response) => {
                    this.editdialog = false;
                    this.appLoading = false;

                    if (response.data.status) {
                        this.msg = "Edited Successfully";
                        this.showsnackbar = true;
                        this.getData(); // Reload data
                    } else {
                        this.msg = response.data.msg;
                        this.showsnackbar = true;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                });
        },
        addImportantDateItem() {
            if (!this.title) {
                this.msg = "Please enter title.";
                this.showsnackbar = true;
                return;
            }
            if (!this.date) {
                this.msg = "Please select a date.";
                this.showsnackbar = true;
                return;
            }

            this.appLoading = true;
            axios({
                url: "/important-dates/add",
                method: "POST",
                data: {
                    title: this.title,
                    date: this.date,
                    description: this.description,
                },
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
            })
                .then((response) => {
                    this.appLoading = false;
                    if (response.data.status) {
                        this.msg = response.data.msg;
                        this.showsnackbar = true;
                        this.addImportantDate = false;

                        // Reset fields
                        this.title = "";
                        this.date = "";
                        this.description = "";
                        this.getData();
                    } else {
                        this.msg = response.data.msg;
                        this.showsnackbar = true;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                });
        },
        openDeleteDialog(item) {
            this.itemToDelete = item;
            this.deletedialog = true;
        },
        confirmDelete() {
            if (this.itemToDelete) {
                this.deleteItem(this.itemToDelete);
            }
            this.deletedialog = false;
        },
        deleteItem(r) {
            // var data = {};
            // data["id"] = r._id;
            this.appLoading = true;
            axios({
                url:  `/important-dates/delete/${r._id} `,
                method: "POST",
                // data: data,
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
            })
                .then((response) => {
                    this.appLoading = false;
                    if (response.data.status) {
                        this.msg = response.data.msg;
                        this.showsnackbar = true;
                        this.getData();
                    } else {
                        this.msg = response.data.msg;
                        this.showsnackbar = true;
                    }
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                });
        },
        getData() {
            this.appLoading = true;
            axios({
                url: "/important-dates/list",
                method: "GET",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                params: {
                    page: this.currentPage,
                    limit: 20,
                },
            })
                .then((response) => {
                    this.appLoading = false;

                    this.importantDates = response.data.data.sort((a, b) => {
                        return new Date(a.date) - new Date(b.date);
                    });

                    this.totalData = this.importantDates.length;
                    this.pages = Math.ceil(this.totalData / (response.data.limit || 20));
                })
                .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                });
        },
        formatDate(item) {
            var dt = new Date(item);
            var day = String(dt.getDate()).padStart(2, '0'); // Ensure two digits for day
            var month = String(dt.getMonth() + 1).padStart(2, '0'); // Ensure two digits for month
            var year = dt.getFullYear();

            return `${day}-${month}-${year}`; // Return in dd-mm-yyyy format
        },
    },
};
</script>
<style>
.tableHead {
    font-size: 15px;
    color: #ffffff;
    font-family: kumbhMedium;
}
</style>